<template>
 <div>
     <div>
         <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 360px;margin: 0">
         <div class="add" @click="headImgUpdate" v-else>
             <span>+</span>
         </div>
         <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
     </div>
     <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
         <el-button @click.native="cancel" >取消</el-button>
         <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
     </div>
 </div>
</template>

<script>
import {imgPostFormData, postFormData} from "@/api/api"
    import { updateCoeffList } from "@/api/url";
    export default {
        name: "ImgUpload",
        props: {
            value: Object
        },
        data() {
            return {
                files: null,
                src: this.value.src,
                id: this.value.id,
                loading: false,
            }
        },
        methods: {

            cancel() {
                this.$emit("close");
            },

            //更改或添加
            headImgUpdate() {
                this.$refs.headImg.click();
            },

            //选取图片
            headImgChanged(e) {
                if(e.target.files[0]) {
                    this.files = e.target.files[0];
                    var windowURL = window.URL || window.webkitURL;
                    this.src = windowURL.createObjectURL(this.files);
                }
            },

            summit() {
                if(!this.src) {
                    this.$message({
                        showClose: true,
                        duration: 2000,
                        message: '图片不能为空',
                        type: 'warning'
                    });
                    return false
                }
                this.loading = true
                let param = new FormData();
                param.append('id', 4);
                param.append('key', 'wechatCodeImg');
                param.append('file', this.files);
                imgPostFormData(updateCoeffList, param).then((data)=>{
                  let {code, msg} = data;
                  if (code == 200) {
                    this.$message({
                      message: msg,
                      type: 'success',
                      duration: 2000,
                    })
                    this.$emit('confirm')
                  }else {
                    this.$message({
                      message: msg,
                      type: 'warning',
                      duration: 2000,
                    })
                  }
                  this.loading = false
                }).catch(()=>{
                  this.loading = false
                })
            }

        }
    }
</script>

<style scoped>
    .add {
        width: 100%;
        height: 100px;
        text-align: center;
        line-height: 100px;
        border: 1px dashed #ececec;
        font-size: 30px;
        cursor: pointer;
        margin: 0 auto
    }
</style>
